import React from 'react';

import { PatientInfo } from '../../patientList/patientStrip/patientStripRedesigned/patientInfoSheet/PatientInfo';
import { PatientListPageLayoutContextMap } from '../../patientList/types';
import type { ReferralRecord } from '../referralPageTypes';

interface ReferralPatientNameCellProps {
  referral: ReferralRecord;
  index: number;
  onNavigateToUnifiedAppointment: (
    imagingPatientVideaId: string,
    unifiedAppointmentId: string,
  ) => void;
}

export const ReferralPatientNameCell = ({
  referral,
  index,
  onNavigateToUnifiedAppointment,
}: ReferralPatientNameCellProps) => {
  // Not a real appointment, but PatientInfo expects an appointment to apply privacy settings
  const appointment = {
    patient: {
      firstName: referral.patientFirstName,
      lastName: referral.patientLastName,
      videaId: referral.imagingPatientVideaId,
    },
    appointment: {
      unifiedId: referral.unifiedAppointmentId,
      start: referral.createdAt, // Use createdAt as fallback
    },
  };

  return (
    <div
      className={`vai-font-semibold vai-scale-75 vai-transition-colors ${
        referral.imagingPatientVideaId
          ? 'vai-cursor-pointer hover:vai-text-blue-600'
          : ''
      }`}
      onClick={() => {
        if (referral.imagingPatientVideaId) {
          onNavigateToUnifiedAppointment(
            referral.imagingPatientVideaId,
            referral.unifiedAppointmentId,
          );
        }
      }}
      onKeyDown={(e) => {
        if (
          (e.key === 'Enter' || e.key === ' ') &&
          referral.imagingPatientVideaId
        ) {
          onNavigateToUnifiedAppointment(
            referral.imagingPatientVideaId,
            referral.unifiedAppointmentId,
          );
        }
      }}
      role={referral.imagingPatientVideaId ? 'button' : undefined}
      tabIndex={referral.imagingPatientVideaId ? 0 : undefined}
    >
      <PatientInfo
        context={PatientListPageLayoutContextMap.Referrals}
        appointment={appointment as any}
        index={index}
        isClickable={!!referral.imagingPatientVideaId}
      />
    </div>
  );
};
